import { Drawer } from "antd"
import './style.scss'
import { ICarEdit } from "../../../../../api/car/carApi"
import { URL_CAR_CATEGORY } from "../../../../../env"
interface DrawerProps {
  isOpen: boolean
  detailCar?: ICarEdit
  closeDrawer: () => void
}
const DrawerInfoCar: React.FC<DrawerProps> = ({
  isOpen, detailCar,
  closeDrawer
}) => {
  return (
    <Drawer
      title={<p className="font-medium fw-500 text-344054 py-3 px-6 bg-FCFCFD">Thông tin xe</p>}
      placement="right"
      closable={false}
      onClose={closeDrawer}
      open={isOpen}
      footer={<div className="py-2 px-6 bg-FCFCFD">
        <button onClick={closeDrawer} className="border-F2F4F7 bg-FCFCFD rounded-2 shadow-active h-8 w-full text-sm font-regular text-344054">Đóng</button>
      </div>}
      rootClassName="custom-drawer"
    >
      <div className=" d-flex flex-column gap-18-px">
        <div className="w-full h-214-px rounded-3 shadow-img">
          <img src='/images/exportImg/img_car_detail.svg' alt="img-car" className="w-full h-full object-fit-cover" />
        </div>
        <div className="d-flex flex-column gap-18-px px-4">
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Xuất xứ</p>
            <div className="d-flex  align-center gap-3" >
              <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.country}</p>
              <img src='/images/exportImg/Flags.svg' alt="" className="w-21-px h-15-px rounded-3-px" />
            </div>
          </div>
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Mã xe</p>
            <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.code}</p>
          </div>
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Thương hiệu</p>
            <div className="d-flex  align-center gap-3" >
              <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.categoryCar}</p>
              <img src={URL_CAR_CATEGORY + detailCar?.categoryCarImage} alt="" className="w-6 h-6" />
            </div>
          </div>
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Phân khúc</p>
            <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.segmentsVehicle}</p>
          </div>
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Dòng xe</p>
            <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.carLines}</p>
          </div>
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Phiên bản xe</p>
            {/* <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.version}</p> */}
          </div>
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Số chỗ</p>
            <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.seatingCapacity}</p>
          </div>
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Màu xe</p>
            <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.color}</p>
          </div>
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Nhóm màu xe</p>
            <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.groupColorTitle} </p>
          </div>
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Nhiên liệu</p>
            <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.fuel}</p>
          </div>
          <div className="d-flex justify-between align-center">
            <p className="text-sm font-regular  text-344054 ">Hệ thùng</p>
            <p className="text-sm font-regular  text-98A2B3 ">{detailCar?.typeBodyVehicle}</p>
          </div>
        </div>
      </div>
    </Drawer>
  )
}
export default DrawerInfoCar
